import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WINDOW } from '../app/WindowProviders';
import { UpdateTopic } from '../app/interface/UpdateTopic';
@Injectable({
  providedIn: 'root'
})
export class ApiOpenmindService {

  private URLs = {
    LoginUser: this.getDomain() + '/API/users/Login',
    GetActivities: this.getDomain() + '/API/users/GetActivity?userid=',
    AddResourceTopicOpen: this.getDomain() + '/API/users/AddResourceTopicOpen',
    AddmoduleWork: this.getDomain() + '/API/users/AddmoduleWork',
    SaveUser: this.getDomain() + '/API/users/AddUser',
    GetUsers: this.getDomain() + '/API/users/GetAllUserId',
    GetUserById: this.getDomain() + '/API/users/GetUserById?Id=',
    RemememberPassword: this.getDomain() + '/API/users/RememberPassword?email=',
    ChangPassword: this.getDomain() + '/API/users/ChangPassword'
  }

  constructor(private http: HttpClient, @Inject(WINDOW) private window: Window) {
  }

  getDomain(): string {
    if (this.window.location.origin.lastIndexOf('http://localhost:', 0) === 0)
      return 'http://localhost:4554';
    else
      return this.window.location.origin;
  }

  RememberPassword(user) {
    return this.http.get(this.URLs.RemememberPassword + user.email);
  }


  ChangePassword(user) {
    let body = "{\n    \"password\": \"" + user.password + "\",\n    \"validation\": \"" + user.validation + "\"";
    body += "}";

    var options = { headers: { 'Content-Type': ['application/json'] } };

    return this.http.post(this.URLs.ChangPassword, body,options);

  }


  LoginUser(user) {
    const body = new HttpParams()
      .set('email', user.email)
      .set('password', user.password);

    return this.http.post(this.URLs.LoginUser, body);
  }


  SaveUser(user) {
    console.log(user);
    let body = "{\n    \"userid\": \"" + user.userid + "\",\n    \"username\": \"" + user.username + "\",\n    \"lastname\" : \"" + user.lastname + "\",\n    \"password\" : \"" + user.password + "\",\n    \"email\" : \"" + user.email + "\"";

    if (user.birthday != null && user.birthday != "") {
      body += ",\n   \"birthday\" : \"" + user.birthday + "\"";
    }

    if (user.mobilenumber != null && user.mobilenumber != "") {
      body += ",\n    \"mobilenumber\" : \"" + user.mobilenumber + "\"";
    }

    if (user.level != null && user.level != "") {
      body += ",\n   \"level\" : \"" + user.level + "\"";
    }


    if (user.website != null && user.website != "") {
      body += ",\n   \"website\" : \"" + user.website + "\"";
    }

    if (user.biography != null && user.biography != "") {
      body += ",\n   \"biography\" : \"" + user.biography + "\"";
    }

    body += "}";

    var options = { headers: { 'Content-Type': ['application/json'] } };
    console.log(user.userid);


    return this.http.post(this.URLs.SaveUser, body, options);
  }

  GetActivity(userId): Observable<any> {
    var form = new FormData();
    form.append("email", "Ljguerrero@yahoo.es");
    form.append("password", "12345");

    const headers = new HttpHeaders();
    headers.set("cache-control", "no-cache");
    headers.set("postman-token", "202dcf3f-08d4-8ec7-05ae-e0ed3f19a106");

    var response = this.http.get(this.URLs.GetActivities + userId, { headers: headers });

    return response;
  }

  GetUserById(userId): Observable<any> {

    const headers = new HttpHeaders();
    headers.set("cache-control", "no-cache");
    headers.set("postman-token", "202dcf3f-08d4-8ec7-05ae-e0ed3f19a106");

    var response = this.http.get(this.URLs.GetUserById + userId, { headers: headers });

    return response;
  }

  GetUsers(): Observable<any> {

    const headers = new HttpHeaders();
    headers.set("cache-control", "no-cache");
    headers.set("postman-token", "202dcf3f-08d4-8ec7-05ae-e0ed3f19a106");

    var response = this.http.get(this.URLs.GetUsers, { headers: headers });

    return response;
  }

  AddModuleWork(DateWork: number, Filepath: string, ModuleId: string, SessionId: string, UserId: string, callback: Function) {
    let body = "{\n   \n    \"DateWork\": " + DateWork + ",\n    \"FilePath\": \"" + Filepath + "\",\n    \"ModuleId\" : \"" + ModuleId + "\",\n    \"SessionId\" : \"" + SessionId + "\",\n    \"UserId\" : \"" + UserId + "\"\n}";
    let Headers = new HttpHeaders();
    Headers.append("Content-Type", "application/json");
    var options = { headers: { 'Content-Type': ['application/json'] } };
    var response = this.http.post(this.URLs.AddmoduleWork, body, options).subscribe(event => {
      callback();
    });

  }

  AddResourceTopic(Datereview: number, TopicId: string, State: string, SessionId: string, UserId: string) {
    let body = "{\n    \"Datereview\": \"" + Datereview + "\",\n    \"TopicId\": \"" + TopicId + "\",\n    \"State\" : \"" + State + "\",\n    \"SessionId\" : \"" + SessionId + "\",\n    \"UserId\" : \"" + UserId + "\"\n}";
    let Headers = new HttpHeaders();
    Headers.append("Content-Type", "application/json");
    var options = { headers: { 'Content-Type': ['application/json'] } };

    var response = this.http.post(this.URLs.AddResourceTopicOpen, body, options).subscribe(event => {
      console.log(event);
    });

  }

  UpdateInfoVideo(updateTopic:UpdateTopic) {
    var options = { headers: { 'Content-Type': ['application/json'] } };
    console.log(`${this.getDomain()}/users/UpdateUserTopic`);
    var response = this.http.post(`${this.getDomain()}/users/UpdateUserTopic`, updateTopic, options).subscribe(event => {
      console.log(event);
    });

  }
}

